import React from 'react';
import { Link } from 'react-router-dom';
import "../../styles.css";

const letters = [
    'SMT',
    'PNC',
    'KRB',
    'JFG',
    'HDW',
    'VLY'
];

function LevelSelectButton(props) {
    return (
        <div className='levelSelectButtonText'>
            <Link to={'/level' + props.level} className='levelSelectButton' style={{ textDecoration: 'none' }}>{letters[props.level - 1]}</Link>
        </div>
    );
}

export default LevelSelectButton;